import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import "./App.css";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import Register from "./pages/Register/Register";
import Dashboard from "./pages/Dashboard/Dashboard";
import ContactUs from "./pages/ContactUs/ContactUs";
import Services from "./pages/Services/Services";
import NotFound from "./pages/NotFound/NotFound";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword.jsx";
// import AboutUs from "./pages/AboutUs/AboutUs";

function App() {
  const user = useSelector((state) => state.user.value);

  return (
    <BrowserRouter>
      <Nav />

      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="register" element={<Register />} />
        <Route path="login" element={user ? <Navigate to="/" /> : <Login />} />
        <Route
          path="dashboard"
          element={user ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route path="contact" element={<ContactUs />} />
        <Route path="services" element={<Services />} />
        <Route path="forgotpassword" element={<ForgotPassword />} />
        <Route path="resetpassword/:userId/:otp" element={<ResetPassword />} />

        {/* <Route path="/about" element={<AboutUs/>} /> */}

        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
